import axios from 'axios'
import Cookies from 'js-cookie'

import store from '~/store'
import * as types from '../mutation-types'
import is from '../../web/plugins/helper/is'
import { regExpTest, checkVariable } from '../../plugins/helper'

/**
 * @param {Object} payload
 */
const removeFaAuth = payload => {
  store.dispatch('save2StepAuth', payload)
}

// remover state
const removeStates = () => {
  Object.keys(types).forEach(strState => {
    if (regExpTest('_START\\b', strState) === true) {
      store.commit(strState)
    }
  })
}

// state
export const state = {
  user: null,
  token: Cookies.get('token'),
}

// mutations
export const mutations = {
  [types.SAVE_TOKEN](state, { token, remember }) {
    state.token = token
    const domain = is.getValueSetting('appDomain')
    let options = { expires: (remember ? 365 : 1) }
    if (checkVariable(domain)) {
      options = { ...options, domain }
    }
    Cookies.set('token', token, options)
  },

  [types.FETCH_USER_SUCCESS](state, { user }) {
    state.user = user
  },

  [types.FETCH_USER_FAILURE](state) {
    state.token = null
    Cookies.remove('token')
    Cookies.remove('fa_auth')
    removeFaAuth({ success: false, remember: false })
    store.commit(types.IS_AUTHENTICATED_START)
  },

  [types.LOGOUT](state) {
    state.user = null
    state.token = null

    Cookies.remove('token')
    Cookies.remove('fa_auth')
    removeFaAuth({ success: false, remember: false })
    store.commit(types.IS_AUTHENTICATED_START)

    removeStates()
  },

  [types.UPDATE_USER](state, { user }) {
    state.user = user
  },
}

// actions
export const actions = {
  saveToken({ commit }, payload) {
    commit(types.SAVE_TOKEN, payload)
  },

  async fetchUser({ commit }) {
    try {
      const { data } = await axios.get('/api/user')

      commit(types.FETCH_USER_SUCCESS, { user: data.data })
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  updateUser({ commit }, payload) {
    commit(types.UPDATE_USER, payload)
  },

  async logout({ commit }) {
    try {
      await axios.post('/api/logout')
      commit(types.LOGOUT)
    } catch (e) {
      console.error(e)
    }
  },
}

// getters
export const getters = {
  authUser: state => state.user,
  authToken: state => state.token,
  authCheck: state => state.user !== null,
}
